import AwardsImage from '/public/images/awards2.png';
import {initTicketingHubEmbed} from "@/components/tour/TicketingHubEmbed";
import CloseIcon from '/public/images/close_green.svg';
import SealCheck from '/public/images/SealCheck.svg';
import GiftBoxIcon from '/public/images/giftbox.svg';
import StarIcon from '/public/images/star_green.svg';
import Image from 'next/image';
import styled from "styled-components";
import {getColor} from "@/styles/ThemeConfig";
import React, {useEffect, useRef, useState} from "react";
import ForceSSRLink from "@/components/other/ForceSSRLink";

const TourBookingWrapper = styled.div`
    background: #fff;
    width: 100%!important;
    z-index: 20;
    overflow-x: auto!important;

    .plugin {
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        box-sizing: border-box;

        > * {
            max-width: 100%;
            box-sizing: border-box;
        }

        /* The newer TicketingHub embed is a bare div their script turns into an
           iframe. It carries no width, so without this the iframe falls back to
           its 300px default and .plugin centres that, leaving a gap either side.
           The older iframe embed is sized through data-width instead, so this
           selector deliberately matches only the new one. */
        [data-th-embed] {
            width: 100%;
        }
    }

    .wrapper{
        padding: 20px;
        border: 1px solid ${getColor('green')};
        border-radius: 10px;
        margin-bottom: 30px;
    }

    iframe {
        border: none;
        width: 100%;
        min-height: 200px;
        transition: height 0.3s ease-in-out;
    }

    .close_btn {
        display: none;
        background: url("${CloseIcon?.src}") no-repeat center right;
        width: 16px;
        height: 16px;
    }

    .heading {
        font-size: 24px;
        line-height: 29px;
        font-family: 'Josefin Sans', sans-serif;
        font-weight: bold;
        text-transform: uppercase;
    }

    .price {
        color: #859f95;
        font-size: 16px;
        line-height: 24px;
        font-family: 'Josefin Sans', sans-serif;
        margin-top: 10px;

        span {
            color: #144733;
            font-size: 36px;
            line-height: 43px;
            font-family: 'Josefin Sans', sans-serif;
            font-weight: bold;
        }

        span:nth-child(2) {
            position: relative;
            color: #859f95;
            font-size: 26px;
            line-height: 43px;
            font-family: 'Josefin Sans', sans-serif;
            font-weight: bold;
        }

        span:nth-child(2)::after {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            height: 2px;
            background-color: #f25c5c; /* red color */
            transform: rotate(-10deg); /* adjust angle as needed */
            transform-origin: left center;
            pointer-events: none;
        }


    }

    .plugin {
        margin-top: 20px;
        padding-bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .buy {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        color: #fff!important;
        background: #144733!important;
        text-decoration: none!important;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 1px;
        transition: background .2s linear;
        padding-top:5px;


        :hover {
            background: #859f95!important;
        }

        .dollar {
            margin-top:-3px;
            background: url("${GiftBoxIcon?.src}");
            width: 20px;
            height: 20px;
            margin-right: 15px;
        }
    }


    .text-red,.text-pt{
        font-size: 14px;
        font-family: 'Inter'!important;
        color:black;
        strong{
            font-family: 'Inter'!important;
            color:black;
        }
    }
    .text-pt-disclaimer{
        font-size: 11px;
        line-height: 18px;
        font-family: 'Inter';
    }
    .text-red{
        //color:red!important;
        font-family: 'Inter';
        color:#144733;
    }


    .text {
        font-size: 16px;
        line-height: 24px;
        font-family: 'Josefin Sans', sans-serif;
        color: #859f95;
        margin-top: 30px;
    }
    a {
        color: ${getColor('gold')}!important;
        text-decoration: underline;
        font-family: 'Inter';
    }

    @media screen and (max-width: 1450px) {
            right: 0;
    }

    @media screen and (max-width: 1400px) {
            top: -140px;
            //padding: 40px 10px 10px 20px !important;
            width: 100%!important;
            padding:0;
            max-width: 100%;

        .wrapper{
            padding:0;

            .heading,
            .text-red,
            .text-pt,
            .text-pt-disclaimer,
            .awards-desktop,
            .bottom-text {
                padding: 0 20px;
            }

            .heading{
                padding-top:20px;
            }

            .plugin{
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left:0px;

                [data-th-embed] {
                    width: calc(100% - 40px);
                }
            }
        }

        .price,
        .low-price,
        .review
        {
            padding-left: 10px;
        }

        .price span {
            font-size: 26px !important;
            line-height: 33px !important;
        }

        .heading {
            padding-left: 10px !important;
        }
    }

    .blue_block{
        background-color: #0a88ff;
        padding: 10px;
        color: #fff!important;
        margin-bottom: 20px;
        a,div,p,span,strong{
            color: #fff!important;
        }
    }


`

const ReviewLine = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #253b2f;
  opacity: 0.9;
`;

const Stars = styled.span`
  color: #f3b33d;
  letter-spacing: 2px;
  font-size: 16px;
    display: flex;
    gap:3px;
    margin-top:-5px;
`;


const LowPriceWrapper = styled.div`
    margin:10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px 5px 5px;
    gap: 5px;
    width: fit-content;
    height: 34px;
    background: rgba(20, 71, 51, 0.14);
    border-radius: 10px;
    flex: none;
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #144733;
    flex-grow: 0;
`;



const extractIframeData = (embedHtml) => {
    // Create a temporary DOM parser
    const parser = new DOMParser();
    const doc = parser.parseFromString(embedHtml, "text/html");

    // Find the iframe element
    const iframe = doc.querySelector("iframe");
    if (!iframe) return null;

    // Extract src attribute
    const src = iframe.getAttribute("src");

    // Extract JSON options from src hash
    let options = null;
    if (src && src.includes("#options=")) {
        try {
            const jsonString = decodeURIComponent(src.split("#options=")[1]);
            options = JSON.parse(jsonString);
        } catch (error) {
            console.error("Error parsing iframe options:", error);
        }
    }

    return {
        src,
        srcBase: src.split("#")[0], // Remove the #options part
        options,
        widget: options?.widget || null,
        width: options?.width || "370px",
        currency: options?.currency || null,
        eventPeriod: options?.["event-period"] || null,
        channel: options?.channel || null,
        products: options?.products || null,
    };
};

export default function VariantBBookingSection({
    embed,
    price,
    crossedPrice = null,
    currency,
    disabledText,
    reviewOverlayData,
    globalBookingLogo,
    customBookingText,
    bookingAwardsImage,
    lowestPriceText,
    lowestPriceFlag,
    reviewsText,
    title,
    ...rest
})
{
    const pluginRef = useRef(null);
    const [scriptData, setScriptData] = useState(null);
    const [isIframe, setIsIframe] = useState();

    useEffect(() => {
        if (!embed) return;

        // 1) Try iframe flow (src + #options)
        const iframeData = extractIframeData(embed);
        if (iframeData) {
            setIsIframe(true);
            setScriptData(iframeData);
            return;
        }

        setIsIframe(false);
        setScriptData(embed);
    }, [embed]);



    useEffect(() => {
        if (scriptData && pluginRef.current && isIframe) {
            // Remove existing iframe(s) inside pluginRef
            const existingIframe = pluginRef.current.querySelector("iframe");
            if (existingIframe) {
                existingIframe.remove(); // ✅ Remove old iframe
            }

            // Remove existing script if already injected
            const existingScript = document.getElementById("ticketinghub-script");
            if (existingScript) {
                existingScript.remove(); // ✅ Remove old script
            }

            // Size the widget to the actual available space so it doesn't render
            // wider than its container and force a horizontal scrollbar on mobile
            const containerWidth = pluginRef.current.clientWidth;
            const width = containerWidth > 0 ? `${Math.floor(containerWidth)}px` : scriptData.width;

            // Inject the TicketingHub checkout script dynamically
            const script = document.createElement("script");
            script.src = "https://assets.ticketinghub.com/checkout.js";
            script.setAttribute("data-widget", scriptData.widget); // Set extracted widget
            script.setAttribute("data-width", width); // Fit container instead of the CMS-configured width
            script.id = "ticketinghub-script";
            script.async = true;

            pluginRef.current.appendChild(script);
        }

        if(scriptData && pluginRef.current && !isIframe){
            pluginRef.current.innerHTML = scriptData;

            return initTicketingHubEmbed(pluginRef.current);
        }
    }, [scriptData,isIframe]);


    return <TourBookingWrapper id={'BOOKING'} {...rest}>
            <div
                className={'wrapper'}
                style={{

                }}
            >
                <h2 className="heading no-mobile">{title ?? 'Book Your Tour'}</h2>
                {
                    disabledText && <div className={'blue_block'}  dangerouslySetInnerHTML={{__html:disabledText}}/>
                }
                {
                    (price) && <div className="price no-mobile" >
                        <span>{currency ?? '€'}{price}</span> {crossedPrice && <span>{currency ?? '€'}{crossedPrice}</span>} / person
                    </div>
                }
                {/*<div dangerouslySetInnerHTML={{__html: embed}}/>*/}

                <div
                    className={'low-price'}
                >
                    <LowPriceWrapper
                    >
                        <Image src={lowestPriceFlag ?? SealCheck} alt={'Lowest Price Flag'} width={20} height={20} style={{width:'auto', height:'20px'}}/>
                        <p style={{fontFamily:'Inter', fontSize:'14px'}}>{lowestPriceText ?? 'Lowest price guarantee'}</p>
                    </LowPriceWrapper>
                </div>

                <div
                    className={'review'}
                >
                    <ReviewLine>
                        <Stars>
                            <Image src={StarIcon} alt={'StarIcon'}/>
                            <Image src={StarIcon} alt={'StarIcon'}/>
                            <Image src={StarIcon} alt={'StarIcon'}/>
                            <Image src={StarIcon} alt={'StarIcon'}/>
                            <Image src={StarIcon} alt={'StarIcon'}/>
                        </Stars>
                        <span style={{fontFamily:'Josefin Sans', color:'#144733'}}>{reviewsText ?? reviewOverlayData?.data?.leftText}</span>
                    </ReviewLine>
                </div>



                {/* TicketingHub widget loads here */}
                <div ref={pluginRef} className="plugin"></div>

                {
                    customBookingText ?
                        <div dangerouslySetInnerHTML={{__html: customBookingText}}/>
                        :
                        <>
                            <div className="text-red" style={{marginBottom:'10px'}}>If you have any issues with payment, please email us at <ForceSSRLink
                                href="mailto:contact@secrettours.com">contact@secrettours.com</ForceSSRLink> with the city, date and time of tour, and
                                how many adult and child's tickets you need so we can assist you.
                            </div>
                            <p className="text-pt" style={{marginBottom:'10px'}}><strong>If a tour is fully booked, or you are looking to book a *Group or Private Tour -
                                please email us about <ForceSSRLink href="/private-bookings">Group &amp; Private Tours</ForceSSRLink> options.</strong></p>
                            <p className="text-pt-disclaimer">*Please note - Group &amp; Private Tours are specifically organised for your
                                group and therefore subject to a premium price. </p>
                        </>
                }


                <div className="awards-desktop">
                    <Image src={bookingAwardsImage?.url ?? globalBookingLogo?.logoImage?.url ?? AwardsImage} alt={bookingAwardsImage?.alt ?? globalBookingLogo?.logoImage?.alt ?? 'Awards'} width="600" height="200" style={{
                        width: '100%', height: 'auto', objectFit: 'contain',
                    }}/>
                </div>
            </div>

        <div className={'bottom-text'}>
            <p style={{textAlign:'center', marginBottom:'10px',color:"#144733"}}>Looking to gift a memorable experience?
                <br/>We've got you!</p>
            <ForceSSRLink href="/buy-gift/" className="buy"><span className="dollar"></span>Buy as a gift</ForceSSRLink>
        </div>

        </TourBookingWrapper>
}
